import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const TageslinieServiceConfig = {
  name: "Tageslinie",
  annotations: []
} as ServiceConfig;